import React from 'react';
import { Link } from 'react-router-dom';
import CurrentUser from '../../CurrentUser';
import CreateTaskForm from './CreateTaskForm';
import TaskView from './TaskView';

const headerStyle = {
  textAlign: "right"
};

const tableHeadStyle = {
  textTransform: "none"
};

const ScheduleLink = ({ title = "Schedule", projectId, sectionId }) => {
  return (
    <Link
      to={`/projects/${projectId}/schedule/${sectionId}`}
      data-icon="&#xe900;"
      data-tooltip="Schedule">{title}</Link>
  );
}

class TaskSection extends React.Component {

  constructor(props) {
    super(props);

    this.onCreate = this.onCreate.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onComplete = this.onComplete.bind(this);
  }

  onCreate(task) {

    const newTask = {
      categoryId: this.props.section.id,
      ...task
    }

    if (this.props.allowCreate && this.props.onCreate) {
      this.props.onCreate(newTask);
    }
  }

  onDelete(task) {
    if (this.props.allowDelete && this.props.onDelete) {
      this.props.onDelete(task);
    }
  }

  onComplete(task) {
    if (this.props.onComplete) {
      this.props.onComplete(task);
    }
  }

  sortTasks(valuesArray) {
    return valuesArray.sort(function (a, b) {
      return new Date(a.attributes.startTime) - new Date(b.attributes.startTime);
    });
  }

  render() {

    const { section, projectId, allowCreate, allowSchedule, onCreate, onDelete, onComplete, ...rest } = this.props;
    const tasks = section.tasks ? this.sortTasks(section.tasks) : [];

    return (
      <CurrentUser
        render={currentUser => (
          <article className="row">
            <header style={headerStyle}>
              <time><strong>{section.name}</strong></time>
              <span>
                {allowSchedule && tasks.length ? <ScheduleLink projectId={projectId} sectionId={section.id} /> : ''}
              </span>
            </header>
            <table>
              <thead>
                <tr>
                  <th style={tableHeadStyle}>Task Period</th>
                  <th style={tableHeadStyle}>Assigned To</th>
                  <th style={tableHeadStyle}>Status</th>
                  <th style={tableHeadStyle}>Hours</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task, index) => (
                  <TaskView
                    {...rest}
                    key={index}
                    task={task}
                    user={currentUser}
                    onDelete={this.onDelete}
                    onComplete={this.onComplete} />
                ))}
              </tbody>
            </table>
            {allowCreate && <CreateTaskForm onCreate={this.onCreate} />}
          </article>)}
      />
    );
  }
}

export default TaskSection;



// WEBPACK FOOTER //
// ./src/components/projects/Tasks/TaskSection.js